import React from 'react';
import Fade from 'react-reveal/Fade';

export const HeaderAnimation = (props) => {
  return (
    <Fade top>
      {props.children}
    </Fade>
  );
}

export const SidebarAnimation = (props) => {
  return (
    <Fade big>
      {props.children}
    </Fade>
  );
}

export const PageAnimation = (props) => {
  return (
    <Fade>
      {props.children}
    </Fade>
  );
}
